<template>
  <div class="skipped-list container-fluid">
    <div class="row skipped-title-row">
      <div class="col-12">{{title}}</div>
    </div>
    <div class="row offers-row">
      <SkippedOffer class="col-12" v-for="(offer, index) in skippedOffers" :class="{ last: index === skippedOffers.length -1 }" :key="offer.displayedOfferId" :offer="offer" @unskipOffer="unskip"></SkippedOffer>
      <div class="col-12 no-skipped-offers" v-if="skippedOffers.length === 0">
        Currently no skipped offers.
      </div>
    </div>
  </div>
</template>
<script>
import SkippedOffer from './mini-offers/SkippedOffer.vue'

export default {
  name: 'SkippedList',
  props: ['skippedOffers', 'title'],
  emits: ['unskipOffer'],
  components: {
    SkippedOffer
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    unskip (offer) {
      this.$emit('unskipOffer', offer)
    }
  }
}
</script>

<style scoped>
.row {
  margin-right: calc(var(--bs-gutter-x) * -1);
  margin-left: calc(var(--bs-gutter-x) * -1);
}
.skipped-list {
  border: 1px solid #faebcc;
  margin-bottom: 20px;
  border-radius: .25em;
}
.skipped-title-row {
  padding: 20px 0;
  border-bottom: 1px solid #faebcc;
  color: #8a6d3b;
  background-color: #fcf8e3;
}
.skipped-offer {
  border-bottom: 1px solid #ddd;
  padding-bottom: 5px;
}
.skipped-offer.last {
  border: none;

}
.no-skipped-offers {
  padding-top: 10px;
  padding-bottom: 25px;
}
@media screen and (min-width: 1200px) {
  .skipped-offer {
    padding-left: calc(var(--bs-gutter-x));
  }
}
</style>
